<template>
     <div>
        <div class="loading-spinner" v-if="!itemLists">
            <base-spinner></base-spinner>
        </div>

        <!--검색 조건 -->
        <div>
            
        </div>

        <!-- 항목 테이블 -->
        <div class="tbl_wrap" v-if="itemLists">
            <table class="tbl">
                <colgroup>
                    <col style="width:5%" />
                    <col style="*" />
                    <col style="width:15%" />
                    <col style="width:20%" />    
                </colgroup>
               
                <tbody>
                    <template v-if="itemLists.data.length > 0">
                        <tr v-for="(item, index) in itemLists.data" :key="index" >
                            <td>{{itemLists.total - itemLists.from + 1 - index}}</td>
                            <td>{{item.item_title}}</td>
                            <td>{{item.count}}</td>
                            <td><display-time :time="item.created_at"/></td>                                                         
                        </tr>  
                    </template>       
                    <template v-else>
                        <tr>
                            <td colspan="4" class="txt-center">사용 내역이 없습니다.</td>                           
                        </tr>
                    </template>    
                </tbody>
            </table>
            <paginate store="item" collection="itemUse"  @paging="getItemValidity" :isMobile="true"/>
        </div>            
    </div>
</template>
<script>
import { myItemUse } from '@/components/mixins/pages/myItemUse.js'
export default {
    name:'mobile_myItemUse',
    props:[
        
    ],
    data(){
        return{

        }
    },
    mixins:[
        myItemUse
    ],
    components:{

    },
    mounted() {
    },
    methods:{
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/table';
td{
    color:#000 !important;
}
</style>